export default class ServerTypes {
  serverTypes = {
    leerlingen: 'LL',
    leerkrachten: 'PS',
    ouders: 'OUDERS',
    vwo: 'VWO',
    student: 'STUDENT',
  }

  isLeerkrachtenWebsite(res) {
    return typeof res === 'string' && res.toUpperCase() === this.serverTypes.leerkrachten
  }

  isLeerlingenWebsite(res) {
    return typeof res === 'string' && res.toUpperCase() === this.serverTypes.leerlingen
  }

  isOudersWebsite(res) {
    return typeof res === 'string' && res.toUpperCase() === this.serverTypes.ouders
  }
  isVwoWebsite(res) {
    return typeof res === 'string' && res.toUpperCase() === this.serverTypes.vwo
  }
  isVwoLLWebsite(res) {
    return typeof res === 'string' && res.toUpperCase() === this.serverTypes.student
  }
}
